import React from 'react';
import { useAddProductList } from './hooks/useAddProductList';
import { StyledContainer } from '../../../components/container/styles';
import { ButtonTheme, RenderForm } from '../../../components';
import { FORM_ADD_PRODUCT } from './forms';
import { Col, Row, Spin } from 'antd';
import { ContainerButton } from '../../../styles/global-style';

export const AddProduct = () => {
  const {
    control,
    setValue,
    getValues,
    categoryList,
    brandList,
    modelList,
    loadingCategory,
    loadingBrand,
    loadingModel,
    productTypeList,
    productGroupCodeList,
    loadingProductType,
    loadingProductGroupCode,
    onSubmit,
    handleSubmit,
    isLoadingAddProduct,
  } = useAddProductList();
  return (
    <Spin
      spinning={
        loadingCategory ||
        loadingBrand ||
        loadingModel ||
        loadingProductType ||
        loadingProductGroupCode
      }
    >
      <StyledContainer>
        <Row gutter={16}>
          <Col span={12}>
            <RenderForm
              forms={FORM_ADD_PRODUCT({
                categoryList,
                brandList,
                modelList,
                productTypeList,
                productGroupCodeList,
              })}
              control={control}
              setValue={setValue}
              getValues={getValues}
            />
            <ContainerButton center>
              {isLoadingAddProduct ? (
                <Spin spinning={isLoadingAddProduct}></Spin>
              ) : (
                <ButtonTheme useFor="SUBMIT" onClick={handleSubmit(onSubmit)} />
              )}
            </ContainerButton>
          </Col>
          <Col span={12}></Col>
        </Row>
      </StyledContainer>
    </Spin>
  );
};
